
;(function($, window, document) {

  const accordions = $('.tms-accordion');

  if (accordions.length > 0) {

    // User action
    $('.accordion-multi-expand .accordion-item button').on('click', function() {
      $item = $(this).parent();
      tms_accordion_toggle($item);
    });

    $('.accordion-single-expand .accordion-item button').on('click', function() {
      $item = $(this).parent();
      tms_accordion_open_only($item);
    });
  
    // Initial state
    $.each($('.accordion-item.pre-open'), function () {
      $item = $(this);
      tms_accordion_open_only($item);
    });
  
  }

})(jQuery, window, document);




function tms_accordion_toggle($item) {
  $control = $item.find('.accordion-item-title');
  $panel = $item.find('.accordion-item-panel');
  $aria = $control.attr('aria-expanded');
  $item.toggleClass('open');
  $control.attr('aria-expanded', ($aria === "true") ? "false" : "true");
  $panel.slideToggle(300);
}


function tms_accordion_open_only($item) {

  const open_id = $('.accordion-item.open').data('id');
  const item_id = $item.data('id');

  // Only action if not already open
  if (open_id === item_id) { return; } 


  // Hide all other
  $('.accordion-item.open').removeClass('open');
  $('.accordion-item-title').attr('aria-expanded', "false");
  $('.accordion-image').fadeOut();
  $('.accordion-item-panel').slideUp(300);

  // Open new
  $control = $item.find('.accordion-item-title');
  $panel = $item.find('.accordion-item-panel');
  $aria = $control.attr('aria-expanded');
  $item.toggleClass('open');
  $item.find('.accordion-image').fadeIn();
  $control.attr('aria-expanded', ($aria === "true") ? "false" : "true");
  $panel.slideToggle(300);
}

  
